import { motion } from "framer-motion";
import { Music, Tv, Award, Globe } from "lucide-react";
import { BOOK_URL, IMAGES } from "@/lib/site";
import { FadeUp } from "@/components/motion-ui";

const stats = [
  { value: "+10", label: "ans d'expérience", icon: Award },
  { value: "TRACE", label: "Caribbean • Urban • Tropical", icon: Tv },
  { value: "500+", label: "femmes transformées", icon: Music },
  { value: "3", label: "formats : visio • domicile • salle", icon: Globe },
];

export default function About() {
  return (
    <section
      id="a-propos"
      data-testid="about-section"
      className="relative px-5 md:px-8 py-24 md:py-32 bg-gradient-to-b from-pink-50 via-white to-cyan-50/40"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <FadeUp className="lg:col-span-5 relative" direction="up" delay={0}>
          <div className="relative rounded-[2.5rem] overflow-hidden border-4 border-white shadow-[0_30px_80px_-20px_rgba(255,0,127,0.4)] bg-gradient-to-br from-pink-100 via-white to-fuchsia-50 p-6">
            <div className="overflow-hidden rounded-2xl">
              <img
                src={IMAGES.equipment}
                alt="Programme d'exercices LaGigaFam"
                className="w-full block"
                style={{ height: "auto", clipPath: "inset(0 0 12% 0)" }}
              />
            </div>
          </div>
          <motion.div
            initial={{ opacity: 0, scale: 0.6, rotate: 4 }}
            whileInView={{ opacity: 1, scale: 1, rotate: -4 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8, delay: 0.3, type: "spring" }}
            className="absolute -bottom-8 right-4 bg-pink-600 text-white rounded-3xl px-6 py-4 shadow-2xl"
          >
            <p className="font-display text-xl font-black uppercase">
              by Perle Lama
            </p>
            <p className="text-xs font-bold uppercase tracking-widest opacity-90">
              Coach diplômée • Artiste
            </p>
          </motion.div>
        </FadeUp>

        <FadeUp className="lg:col-span-7" delay={0.15}>
          <span className="inline-block text-xs font-bold uppercase tracking-[0.25em] text-pink-600 mb-3">
            ✦ L'institut
          </span>
          <h2 className="font-display text-4xl md:text-6xl font-black uppercase tracking-tight text-neutral-900 leading-[0.95]">
            Une méthode <span className="text-pink-600">unique</span>,
            <br />
            une énergie <span className="text-cyan-500">tropicale</span>.
          </h2>
          <p className="mt-6 text-lg text-neutral-700 leading-relaxed font-medium">
            Perle Lama, coach de sport diplômée et chanteuse à succès, est
            l'animatrice star de{" "}
            <span className="font-bold">Sport Fitness Island Minutes</span> sur
            TRACE TV (Caribbean, Urban, Tropical). Elle a créé LaGigaFam : un
            concept unique alliant renforcement musculaire avec élastiques
            signature, drainage lymphatique et programmes anti burn-out.
          </p>
          <p className="mt-4 text-base text-neutral-600 leading-relaxed">
            Ici on bouge, on transpire, on rit, on chante. Tu repars sculptée,
            drainée, allumée. Promis. 💖
          </p>

          <div className="mt-10 grid grid-cols-2 gap-4">
            {stats.map((s, i) => {
              const Icon = s.icon;
              return (
                <div
                  key={i}
                  data-testid={`about-stat-${i}`}
                  className="bg-white rounded-2xl p-5 border border-pink-100 shadow-sm hover:shadow-md transition-shadow"
                >
                  <Icon className="text-pink-600 mb-2" size={20} />
                  <p className="font-display text-2xl md:text-3xl font-black text-neutral-900">
                    {s.value}
                  </p>
                  <p className="text-xs font-semibold text-neutral-600 mt-1">
                    {s.label}
                  </p>
                </div>
              );
            })}
          </div>

          <a
            href={BOOK_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="about-book-button"
            className="mt-10 inline-flex items-center gap-2 bg-pink-600 hover:bg-pink-700 text-white px-7 h-14 rounded-full font-bold shadow-[0_12px_40px_rgba(255,0,127,0.35)] hover:scale-[1.03] transition-transform"
          >
            Rejoindre la GigaFam ✨
          </a>
        </FadeUp>
      </div>
    </section>
  );
}
